import { useShadow, useWidgetStore } from '../../state/createWidgetStore';
import { t } from '../../i18n';

export function TurnErrorActions({ messageId, turnId }: { messageId: string; turnId: string }) {
  const shadow = useShadow();
  const updateMessage = useWidgetStore((s) => s.updateMessage);

  const dispatch = (type: string) => {
    (shadow.host as HTMLElement).dispatchEvent(
      new CustomEvent(type, { bubbles: true, composed: true, detail: { turnId } }),
    );
  };

  const handleDismiss = () => {
    updateMessage(messageId, { turnError: undefined });
    dispatch('mcp-chat:turn-dismiss');
  };

  return (
    <div className="form-actions turn-error-actions">
      <button className="form-submit" onClick={() => dispatch('mcp-chat:turn-retry')}>{t('retry')}</button>
      <button className="form-cancel" onClick={handleDismiss}>{t('dismiss')}</button>
    </div>
  );
}
